import { render } from "./FollowingTabs.vue?vue&type=template&id=18084d58&ts=true"
import script from "./FollowingTabs.vue?vue&type=script&lang=ts"
export * from "./FollowingTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__